// extracted by mini-css-extract-plugin
module.exports = {"splash-screen":"SplashScreen_splash-screen__3oRIu","card":"SplashScreen_card__3gPdq","logo":"SplashScreen_logo__7w2hF","oscillate":"SplashScreen_oscillate__1lofI"};